import { useEffect } from "react";
import { site } from "../data/site";

/**
 * Per-route <title> and meta description. Without this every route reported the
 * same title, which is what search engines and browser history end up showing.
 */
const PageMeta = ({ title, description }) => {
  useEffect(() => {
    // Sub-routes read "About - Chafic Achour"; the home page (no title)
    // gets the full positioning line that search results show.
    document.title = title ? `${title} - ${site.name}` : site.metaTitle;

    if (description) {
      document
        .querySelector('meta[name="description"]')
        ?.setAttribute("content", description);
    }
  }, [title, description]);

  return null;
};

export default PageMeta;
